export default "__VITE_ASSET__sHCK8qyU__"